import React, { useState, useEffect } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import { useForm } from 'react-hook-form'
import axios from 'axios'
import { optionalPasswordValidationRules } from '../../Utils/passwordValidation'

function EditAdmin({ adminId, onClose }) {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm()

  useEffect(() => {
    if (adminId) {
      getSingleUser(adminId)
    }
  }, [adminId])

  const getSingleUser = async (id) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}edit/${id}`
    )
    if (response.status === 200) {
      setValue('first_name', response.data.first_name)
      setValue('middle_name', response.data.middle_name)
      setValue('last_name', response.data.last_name)
      setValue('email', response.data.email)
      setValue('phone', response.data.phone)
      setValue('notes', response.data.notes)
    }
  }

  const generateError = (err) =>
    toast.error(err, {
      position: 'top-center',
    })

  const onSubmit = async (values) => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}update_parent/${adminId}`,
        {
          ...values,
          role: 'subadmin',
          id: adminId,
        },
        {
          withCredentials: true,
        }
      )
      if (data) {
        if (data.errors) {
          const { name, email, password } = data.errors
          if (name) generateError(name)
          else if (email) generateError(email)
          else if (password) generateError(password)
        } else {
          if (onClose) onClose()
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div
      className="content-body container font-sans"
      style={{
        padding: 26,
        borderRadius: 20,
        background: '#fff',
        boxShadow: '0px 18px 60px 0px rgba(226, 236, 249, 0.50)',
      }}
    >
      <h4 className="card-title text-[#030303] font-bold text-xl pb-6">
        Edit Admin
      </h4>
      <form
        className="form-sample"
        onSubmit={handleSubmit(onSubmit)}
        autoComplete="off"
      >
        <div className="grid grid-cols-2 gap-x-6 gap-y-4 pt-2">
          <div>
            <label className="block text-[#535862] font-medium mb-1">
              First Name <span className="error text-[#DE3C7D]">*</span>
            </label>
            <input
              type="text"
              name="first_name"
              className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px] focus:border-[#DE3C7D]"
              {...register('first_name', {
                required: 'First Name is required',
              })}
            />
            {errors.first_name && (
              <p className="text-[#DE3C7D] text-xs mt-1">
                {errors.first_name.message}
              </p>
            )}
          </div>
          <div>
            <label className="block text-[#535862] font-medium mb-1">
              Last Name <span className="error text-[#DE3C7D]">*</span>
            </label>
            <input
              type="text"
              name="last_name"
              className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px] focus:border-[#DE3C7D]"
              {...register('last_name', { required: 'Last Name is required' })}
            />
            {errors.last_name && (
              <p className="text-[#DE3C7D] text-xs mt-1">
                {errors.last_name.message}
              </p>
            )}
          </div>
          <div>
            <label className="block text-[#535862] font-medium mb-1">
              Phone
            </label>
            <input
              type="text"
              name="phone"
              className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px] focus:border-[#DE3C7D]"
              {...register('phone')}
            />
          </div>
          <div>
            <label className="block text-[#535862] font-medium mb-1">
              Password <span className="error text-[#DE3C7D]">*</span>
            </label>
            <input
              type="password"
              name="new_password"
              className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px] focus:border-[#DE3C7D]"
              {...register('password', optionalPasswordValidationRules)}
              autoComplete="new-password"
            />
            {errors.Password && (
              <p className="text-[#DE3C7D] text-xs mt-1">
                {errors.Password.message}
              </p>
            )}
          </div>
          <div className="col-span-2">
            <label className="block text-[#535862] font-medium mb-1">
              Email Address <span className="error text-[#DE3C7D]">*</span>
            </label>
            <input
              type="email"
              name="new_email"
              className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px] focus:border-[#DE3C7D]"
              {...register('email', {
                required: 'Email is required',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'Enter valid email',
                },
              })}
              autoComplete="off"
            />
            {errors.email && (
              <p className="text-[#DE3C7D] text-xs mt-1">
                {errors.email.message}
              </p>
            )}
          </div>
          <div className="col-span-2">
            <label className="block text-[#535862] font-medium mb-1">
              Additional Notes
            </label>
            <textarea
              className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px] focus:border-[#DE3C7D]"
              name="notes"
              {...register('notes')}
              style={{ height: '120px' }}
            ></textarea>
          </div>
        </div>
        <div className="flex justify-start gap-3 mt-8">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-md border border-[#F0F0F0] text-[#535862] bg-white hover:bg-neutral-50 transition-colors font-medium"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 rounded-md bg-[#DE3C7D] text-white font-medium hover:bg-[#c8356f] transition-colors"
          >
            Submit
          </button>
        </div>
      </form>
      <ToastContainer />
    </div>
  )
}

export default EditAdmin
